import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import classNames from "classnames";

import {
  CPage,
  CTagFilterDropDown,
  CFilterDropDown
} from "@appcues/component-library";

import SelectSegmentDropDown from "components/Common/SelectSegmentDropDown";
import SearchBar from "components/Common/SearchBar";

import {
  getSortOption,
  getFlowStatusDropdownItems,
  getFlowCreatedByDropdownItems,
  getSortOptionsDropdownItems
} from "helpers/view";
import {
  setFlowLayoutType,
  setFlowStatusFilter,
  setFlowSegmentFilter,
  setFlowCreatedByFilter,
  setFlowSearchFilter,
  setFlowTagsFilter,
  setFlowSortOption
} from "actions/view";
import { FLOW_LAYOUT } from "constants/view";

export class StepViewControls extends Component {
  onChangeSearchInput = searchFilter => {
    const {
      actions: { setFlowSearchFilter }
    } = this.props;
    setFlowSearchFilter(searchFilter);
  };

  setViewtype = type => {
    const {
      flowLayout,
      actions: { setFlowLayoutType }
    } = this.props;

    if (!this.isValidOption(flowLayout, type)) {
      return;
    }

    setFlowLayoutType(type);
  };

  setListView = () => {
    this.setViewtype(FLOW_LAYOUT.LIST);
  };

  setGridView = () => {
    this.setViewtype(FLOW_LAYOUT.GRID);
  };

  setStatusFilter = status => {
    const {
      statusFilter,
      actions: { setFlowStatusFilter }
    } = this.props;

    if (!this.isValidOption(statusFilter, status)) {
      return;
    }

    setFlowStatusFilter(status);
  };

  setSegmentFilter = segmentId => {
    const {
      segmentFilter,
      actions: { setFlowSegmentFilter }
    } = this.props;

    if (!this.isValidOption(segmentFilter, segmentId)) {
      return;
    }

    setFlowSegmentFilter(segmentId);
  };

  setCreatedByFilter = userId => {
    const {
      createdByFilter,
      actions: { setFlowCreatedByFilter }
    } = this.props;

    if (!this.isValidOption(createdByFilter, userId)) {
      return;
    }

    setFlowCreatedByFilter(userId);
  };

  setTagsFilter = tagsValues => {
    const {
      actions: { setFlowTagsFilter }
    } = this.props;
    setFlowTagsFilter(tagsValues);
  };

  setSortOption = selectedSortOption => {
    const {
      sortOption,
      actions: { setFlowSortOption }
    } = this.props;
    if (!this.isValidOption(sortOption, selectedSortOption)) {
      return;
    }

    setFlowSortOption(selectedSortOption);
  };

  isValidOption = (prevOption, newOption) => {
    return prevOption !== newOption;
  };

  render() {
    const {
      users,
      tagsDropdownItems,
      flowLayout,
      statusFilter,
      segmentFilter,
      createdByFilter,
      tagsFilter,
      searchFilter
    } = this.props;

    const flowStatusDropdownItems = getFlowStatusDropdownItems();
    const flowCreatedByDropdownItems = getFlowCreatedByDropdownItems(users);

    const sortDropdownOptions = getSortOptionsDropdownItems();
    const sortOption = getSortOption(this.props.sortOption);

    return (
      <React.Fragment>
        <CPage.SecondBar>
          <StyledFilterControls>
            <CFilterDropDown
              className="filter"
              indicatorIconClass="fas fa-flag"
              options={flowStatusDropdownItems}
              onChange={this.setStatusFilter}
              placeholder="Any Status"
              value={statusFilter}
            />
            <CTagFilterDropDown
              className="filter"
              isMultiSelect
              options={tagsDropdownItems}
              value={tagsFilter || []}
              onChange={this.setTagsFilter}
              placeholder="Any Tag"
              minMenuWidth="220px"
            />
            <SelectSegmentDropDown
              className="filter"
              value={segmentFilter || ""}
              placeholder="Any Segment"
              shouldSortSegmentsList
              onChange={value => this.setSegmentFilter(value)}
              useFilterDropDown
            />
            <CFilterDropDown
              className="filter"
              options={flowCreatedByDropdownItems}
              onChange={this.setCreatedByFilter}
              placeholder="Any Teammate"
              value={createdByFilter}
            />
            <div className="view-toggles">
              <div
                onClick={this.setGridView}
                className={classNames(
                  "view-toggle-icon",
                  flowLayout === FLOW_LAYOUT.GRID && "selected-layout"
                )}
              >
                <i className="fas fa-th-large" />
              </div>
              <div
                onClick={this.setListView}
                className={classNames(
                  "view-toggle-icon",
                  flowLayout === FLOW_LAYOUT.LIST && "selected-layout"
                )}
              >
                <i className="fas fa-th-list" />
              </div>
            </div>
          </StyledFilterControls>
        </CPage.SecondBar>
        <CPage.Container>
          <StyledSortControls>
            <div className="sort-view-item">
              <SearchBar
                className="search-row"
                placeholder={"Search flows"}
                value={searchFilter || ""}
                handleNewSearchValue={searchValue =>
                  this.onChangeSearchInput(searchValue)
                }
              />
            </div>
            <div className="sort-view-item">
              <div className="sort-controls">
                <CFilterDropDown
                  options={sortDropdownOptions}
                  onChange={this.setSortOption}
                  value={sortOption}
                  selectedByDefault
                  indicatorIconClass="fas fa-sort"
                  placeholder="Sort by..."
                  minMenuWidth="200px"
                  isClearable={false}
                />
              </div>
            </div>
          </StyledSortControls>
        </CPage.Container>
      </React.Fragment>
    );
  }
}

const StyledFilterControls = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px 0;

  > .filter + .filter {
    margin-left: 18px;
  }

  .view-toggles {
    margin-left: auto;
    display: flex;

    .view-toggle-icon {
      margin: 5px 0 5px 12px;
      cursor: pointer;
      color: ${props => props.theme["$gray-50"]};
      font-size: 22px;

      &.selected-layout {
        color: ${props => props.theme["$blue"]};
      }
    }
  }
`;

const StyledSortControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;

  p {
    color: ${props => props.theme["$gray-50"]};
    margin-bottom: 0;
    margin-right: 0.25rem;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.8px;
    line-height: 1em;
  }

  a.button {
    border: 0px;
    padding: 0 10px;
    font-weight: 400;
    font-size: 16px;
    color: ${props => props.theme["$gray-70"]};
  }

  .search-row {
    color: ${props => props.theme["$gray-50"]};
  }

  .sort-view-row {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .sort-view-item {
      display: flex;
      align-items: center;

      .flow-list-counter {
        margin-left: 15px;

        h4 {
          font-weight: 600;
          font-size: ${props => props.theme["$font-size-large"]};
          margin-top: 0;
          margin-bottom: 5px;
        }

        p {
          margin: 0;
          color: ${props => props.theme["$gray-30"]};
        }

        strong {
          font-weight: 600;
        }
      }
    }
  }
`;

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setFlowCreatedByFilter,
        setFlowLayoutType,
        setFlowSearchFilter,
        setFlowSegmentFilter,
        setFlowSortOption,
        setFlowStatusFilter,
        setFlowTagsFilter
      },
      dispatch
    )
  };
}

export default connect(null, mapDispatchToProps)(StepViewControls);
